// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LoginPage.css - 현재 앱 스타일과 유사한 로그인 페이지 */

.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: calc(100vh / var(--app-zoom, 1));
    /* 단색 페이지 배경 — 카드 형태가 아닌 페이지 한가운데 폼 배치 */
    background: var(--color-bg, #ffffff);
    padding: 20px;
    box-sizing: border-box;
}

.login-card {
    /* 카드 그림자/배경/border-radius 제거 — 페이지 콘텐츠로 녹아들게.
       max-width 만 유지해 가독성 보장. 가운데 폼 묶음 형태. */
    background: transparent;
    box-shadow: none;
    border: none;
    border-radius: 0;
    padding: 32px 24px;
    width: 100%;
    max-width: 400px;
    position: relative;
}

.login-header {
    text-align: center;
    margin-bottom: 30px;
}

.login-logo {
    width: 100%;
    max-width: 200px;
    height: auto;
    margin: 0 auto 30px;
    display: block;
    object-fit: contain;
}

.login-title {
    font-size: 28px;
    font-weight: 700;
    color: #333;
    margin: 0 0 8px 0;
    letter-spacing: -0.5px;
}

.login-subtitle {
    color: #666;
    margin: 0;
    font-size: 14px;
    font-weight: 400;
}

.login-form {
    width: 100%;
}

.form-group {
    margin-bottom: 24px;
}

.form-label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
}

.form-input {
    width: 100%;
    padding: 12px 16px;
    border: 2px solid #e1e5e9;
    border-radius: 8px;
    font-size: 14px;
    background-color: #fff;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.form-input:focus {
    outline: none;
    border-color: #6c757d;
    box-shadow: 0 0 0 3px rgba(108, 117, 125, 0.1);
}

.form-input:disabled {
    background-color: #f8f9fa;
    cursor: not-allowed;
}

.form-input::placeholder {
    color: #adb5bd;
}

.error-message {
    background-color: #ffeaa7;
    border: 1px solid #fdcb6e;
    color: #e17055;
    padding: 12px 16px;
    border-radius: 6px;
    font-size: 14px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.error-icon {
    font-size: 16px;
    flex-shrink: 0;
}

.error-text {
    flex: 1 1;
    text-align: left;
}

.button-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 24px;
}

.login-button {
    width: 100%;
    padding: 14px 20px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: center;
    position: relative;
    overflow: hidden;
}

.login-button.primary {
    background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
    color: white;
}

.login-button.primary:hover:not(:disabled) {
    background: linear-gradient(135deg, #5a6268 0%, #3d4142 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}

.login-button.secondary {
    background-color: #f8f9fa;
    color: #495057;
    border: 2px solid #e9ecef;
}

.login-button.secondary:hover:not(:disabled) {
    background-color: #e9ecef;
    border-color: #dee2e6;
    transform: translateY(-1px);
}

.login-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
    box-shadow: none !important;
}

/* 데스크톱 설치 버전 다운로드 섹션 — manifest 있을 때만 표시 */
.login-downloads {
    margin-top: 16px;
    padding: 12px 14px;
    border: 1px solid #e1e5e9;
    border-radius: 8px;
    background: #fafbfc;
}
.login-downloads-title {
    font-size: 13px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 8px;
}
.login-downloads-version {
    font-size: 11px;
    color: #6b7280;
    font-weight: 400;
    margin-left: 4px;
}
.login-downloads-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
}
.login-download-link {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 6px;
    text-decoration: none;
    padding: 6px 10px;
    border-radius: 6px;
    font-size: 12px;
    color: #1e40af;
    background: rgba(59, 130, 246, 0.06);
    border: 1px solid rgba(59, 130, 246, 0.2);
    transition: background 150ms ease, border-color 150ms ease;
}
.login-download-link:hover {
    background: rgba(59, 130, 246, 0.14);
    border-color: rgba(59, 130, 246, 0.45);
}
.login-download-label {
    font-weight: 600;
}
.login-download-size {
    font-size: 11px;
    color: #6b7280;
    font-weight: 400;
}
.login-download-count {
    font-size: 11px;
    color: #4b5563;
    font-weight: 500;
    background: rgba(59, 130, 246, 0.10);
    border: 1px solid rgba(59, 130, 246, 0.25);
    border-radius: 10px;
    padding: 1px 7px;
    line-height: 1.3;
}
[data-theme="dark"] .login-download-count {
    color: #cbd5e1;
    background: rgba(108, 182, 255, 0.14);
    border-color: rgba(108, 182, 255, 0.32);
}
.login-download-desc {
    font-size: 11px;
    color: #4b5563;
    flex: 1 1 100%;
    line-height: 1.35;
}

.login-footer {
    text-align: center;
    border-top: 1px solid #e9ecef;
    padding-top: 24px;
    margin-top: 24px;
}

.footer-text {
    color: #6c757d;
    font-size: 13px;
    line-height: 1.5;
    margin: 0 0 16px 0;
}

.demo-info {
    background-color: #f8f9fa;
    padding: 12px;
    border-radius: 6px;
    border: 1px solid #e9ecef;
}

.demo-info small {
    color: #495057;
    font-size: 12px;
}

/* 로딩 상태 애니메이션 */
.login-button.primary:disabled {
    background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
    position: relative;
}

.login-button.primary:disabled::after {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    animation: loading 1.5s infinite;
}

@keyframes loading {
    0% {
        left: -100%;
    }
    100% {
        left: 100%;
    }
}

/* 회원가입 관련 스타일 */
.signup-form {
    width: 100%;
}

/* 목업 모드 관련 스타일 */
.mock-info {
    margin-top: 12px;
}

.mock-message {
    background-color: #fff3e0;
    border: 1px solid #ffb74d;
    color: #e65100;
    padding: 12px 16px;
    border-radius: 8px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
}

.mock-icon {
    font-size: 16px;
    flex-shrink: 0;
    margin-top: 2px;
}

.mock-text p {
    margin: 0 0 8px 0;
    font-size: 13px;
    line-height: 1.4;
}

.mock-text p:last-child {
    margin-bottom: 0;
}

.show-mock-code {
    background: #ff9800;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    font-weight: 500;
    margin-top: 8px;
}

.show-mock-code:hover {
    background: #f57c00;
}

.mock-complete-info {
    margin: 16px 0;
}

.mock-credentials {
    background-color: #e8f5e8;
    border: 1px solid #81c784;
    color: #2e7d32;
    padding: 16px;
    border-radius: 8px;
    display: flex;
    align-items: flex-start;
    gap: 12px;
}

.mock-credentials .mock-text p {
    margin: 0 0 4px 0;
    font-size: 13px;
    line-height: 1.4;
}

.mock-credentials .mock-note {
    font-size: 11px;
    color: #4caf50;
    font-style: italic;
    margin-top: 8px;
}

.verification-info {
    margin-bottom: 20px;
}

.info-message {
    background-color: #e3f2fd;
    border: 1px solid #90caf9;
    color: #1565c0;
    padding: 16px;
    border-radius: 8px;
    display: flex;
    align-items: flex-start;
    gap: 12px;
}

.info-icon {
    font-size: 20px;
    flex-shrink: 0;
    margin-top: 2px;
}

.info-text p {
    margin: 0 0 8px 0;
    font-size: 14px;
    line-height: 1.5;
}

.info-text p:last-child {
    margin-bottom: 0;
}

.complete-message {
    text-align: center;
    padding: 20px 0;
}

.success-icon {
    font-size: 48px;
    margin-bottom: 16px;
}

.complete-message h3 {
    color: #2e7d32;
    margin: 0 0 16px 0;
    font-size: 20px;
    font-weight: 600;
}

.complete-message p {
    color: #4a5568;
    margin: 0 0 12px 0;
    font-size: 14px;
    line-height: 1.5;
}

.auth-toggle {
    text-align: center;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #e9ecef;
}

.toggle-link {
    background: none;
    border: none;
    color: #6c757d;
    font-size: 14px;
    cursor: pointer;
    text-decoration: none;
    padding: 8px 0;
    transition: color 0.2s ease;
}

.toggle-link:hover {
    color: #495057;
}

.toggle-link strong {
    color: #007bff;
    font-weight: 600;
}

.toggle-link strong:hover {
    text-decoration: underline;
}

/* 반응형 디자인 */
@media (max-width: 480px) {
    .login-container {
        padding: 10px;
    }
    
    .login-card {
        padding: 30px 20px;
    }
    
    .login-title {
        font-size: 24px;
    }
    
    .info-message {
        padding: 12px;
        gap: 8px;
    }
    
    .info-text p {
        font-size: 13px;
    }
}

/* 패스워드 찾기 관련 스타일 */
.forgot-password-form {
    /* 기본 signup-form 스타일과 동일하게 유지 */
}

.forgot-password-link {
    text-align: center;
    margin-top: 15px;
}

.link-button {
    background: none;
    border: none;
    color: #007bff;
    font-size: 13px;
    cursor: pointer;
    text-decoration: underline;
    padding: 5px 0;
    transition: color 0.2s ease;
}

.link-button:hover {
    color: #0056b3;
    text-decoration: none;
}

/* 성공/에러 메시지에 작은 텍스트 스타일 추가 */
.success-text small,
.error-text small {
    display: block;
    margin-top: 8px;
    opacity: 0.8;
    font-style: italic;
}

/* 패스워드 저장 체크박스 스타일 */
.checkbox-label {
    display: flex;
    align-items: center;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    font-size: 14px;
    color: #495057;
    margin-bottom: 0;
}

.checkbox-input {
    margin-right: 8px;
    width: 16px;
    height: 16px;
    cursor: pointer;
    accent-color: #6c757d;
}

.checkbox-text {
    flex: 1 1;
    font-weight: 500;
}

.checkbox-label:hover .checkbox-text {
    color: #333;
}

/* ============================================================
 * 다크 모드 — [data-theme="dark"] 활성 시 적용
 * 시스템 토글로 라이트/다크 자동 전환. 모든 색은 변수 또는 다크 톤 hardcode.
 * ============================================================ */
[data-theme="dark"] .login-container {
    background: var(--color-bg, #1e1e1e);
}
[data-theme="dark"] .login-card {
    /* 카드 시각 효과 제거 — 다크 페이지에 자연스럽게 녹게 */
    background: transparent;
    box-shadow: none;
    border: none;
    color: var(--color-text);
}
/* 로고는 라이트(logo1.png) / 다크(logo1_dark.png) 별도 PNG 로 분기 (LoginPage.js).
   CSS filter 는 더 이상 사용하지 않음. */
[data-theme="dark"] .login-title {
    color: var(--color-text);
}
[data-theme="dark"] .login-subtitle {
    color: var(--color-text-secondary);
}
[data-theme="dark"] .form-label {
    color: var(--color-text);
}
[data-theme="dark"] .form-input {
    background-color: var(--color-input-bg, #3c3c3c);
    border-color: var(--color-input-border, #555);
    color: var(--color-text);
    /* native 자동완성 드롭다운, spinner, 비밀번호 토글 아이콘 등이 다크 톤으로 렌더되게 */
    color-scheme: dark;
}
[data-theme="dark"] .form-input:focus {
    border-color: var(--color-accent-fg);
    box-shadow: 0 0 0 3px rgba(108, 182, 255, 0.18);
}
[data-theme="dark"] .form-input:disabled {
    background-color: rgba(60, 60, 60, 0.5);
    color: var(--color-text-muted);
}
[data-theme="dark"] .form-input::placeholder {
    color: var(--color-text-muted, #777);
}
/* 브라우저 자동완성 (autofill) 시 강제 노란/흰 배경 덮기 — Chrome/Safari 의 -webkit-autofill 트릭.
   inset box-shadow 로 배경을 채우고 -webkit-text-fill-color 로 글자색 지정. */
[data-theme="dark"] .form-input:-webkit-autofill,
[data-theme="dark"] .form-input:-webkit-autofill:hover,
[data-theme="dark"] .form-input:-webkit-autofill:focus,
[data-theme="dark"] .form-input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px var(--color-input-bg, #3c3c3c) inset !important;
    -webkit-text-fill-color: var(--color-text, #d4d4d4) !important;
    caret-color: var(--color-text, #d4d4d4);
    -webkit-transition: background-color 5000s ease-in-out 0s;
    transition: background-color 5000s ease-in-out 0s;     /* autofill 색 전환 지연 — 렌더 직후 깜박임 회피 */
    border-color: var(--color-input-border, #555) !important;
}
/* 라이트 모드 autofill 도 색상계 일관성을 위해 명시 (브라우저 기본 노란 배경 → 흰 배경) */
.form-input:-webkit-autofill,
.form-input:-webkit-autofill:hover,
.form-input:-webkit-autofill:focus,
.form-input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px #ffffff inset;
    -webkit-text-fill-color: #333;
    -webkit-transition: background-color 5000s ease-in-out 0s;
    transition: background-color 5000s ease-in-out 0s;
}

[data-theme="dark"] .error-message {
    background-color: rgba(229, 115, 115, 0.12);
    border-color: rgba(229, 115, 115, 0.4);
    color: #ff8a80;
}
[data-theme="dark"] .info-message {
    background-color: rgba(108, 182, 255, 0.12);
    border-color: rgba(108, 182, 255, 0.4);
    color: #93c5fd;
}
[data-theme="dark"] .mock-message {
    background-color: rgba(255, 152, 0, 0.12);
    border-color: rgba(255, 152, 0, 0.4);
    color: #ffb74d;
}
[data-theme="dark"] .mock-credentials {
    background-color: rgba(129, 199, 132, 0.12);
    border-color: rgba(129, 199, 132, 0.4);
    color: #a5d6a7;
}
[data-theme="dark"] .mock-credentials .mock-note {
    color: #81c784;
}

[data-theme="dark"] .login-button.primary {
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
    color: #fff;
}
[data-theme="dark"] .login-button.primary:hover:not(:disabled) {
    background: linear-gradient(135deg, #6cb6ff 0%, #3b82f6 100%);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.45);
}
[data-theme="dark"] .login-button.primary:disabled {
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
    opacity: 0.55;
}
[data-theme="dark"] .login-button.secondary {
    background-color: var(--color-btn-bg, #3c3c3c);
    color: var(--color-text);
    border-color: var(--color-btn-border, #555);
}
[data-theme="dark"] .login-button.secondary:hover:not(:disabled) {
    background-color: var(--color-hover, #37373d);
    border-color: var(--color-hover-border, #5a5a5a);
}

[data-theme="dark"] .login-footer,
[data-theme="dark"] .auth-toggle {
    border-top-color: var(--color-border, #404040);
}
[data-theme="dark"] .footer-text {
    color: var(--color-text-secondary);
}
[data-theme="dark"] .demo-info {
    background-color: rgba(255, 255, 255, 0.04);
    border-color: var(--color-border, #404040);
}
[data-theme="dark"] .demo-info small {
    color: var(--color-text-secondary);
}

[data-theme="dark"] .toggle-link {
    color: var(--color-text-secondary);
}
[data-theme="dark"] .toggle-link:hover {
    color: var(--color-text);
}
[data-theme="dark"] .toggle-link strong {
    color: var(--color-accent-fg);
}

[data-theme="dark"] .link-button {
    color: var(--color-accent-fg);
}
[data-theme="dark"] .link-button:hover {
    color: var(--color-text); background: var(--color-hover);}

[data-theme="dark"] .complete-message h3 {
    color: #81c784;
}
[data-theme="dark"] .complete-message p {
    color: var(--color-text-secondary);
}

[data-theme="dark"] .checkbox-label {
    color: var(--color-text-secondary);
}
[data-theme="dark"] .checkbox-input {
    accent-color: var(--color-accent, #6cb6ff);
    color-scheme: dark;        /* checkbox native 위젯 다크 톤 (체크 안 된 상태의 흰색 박스 → 어두운 박스) */
}
[data-theme="dark"] .checkbox-label:hover .checkbox-text {
    color: var(--color-text);
}

/* 다크 모드 — 다운로드 섹션 */
[data-theme="dark"] .login-downloads {
    background: rgba(255, 255, 255, 0.03);
    border-color: var(--color-border, #404040);
}
[data-theme="dark"] .login-downloads-title {
    color: var(--color-text);
}
[data-theme="dark"] .login-downloads-version {
    color: var(--color-text-muted);
}
[data-theme="dark"] .login-download-link {
    color: #93c5fd;
    background: rgba(108, 182, 255, 0.08);
    border-color: rgba(108, 182, 255, 0.3);
}
[data-theme="dark"] .login-download-link:hover {
    background: var(--color-hover);
    border-color: var(--color-hover-border, #5a5a5a);
}
[data-theme="dark"] .login-download-size {
    color: var(--color-text-muted);
}
[data-theme="dark"] .login-download-desc {
    color: var(--color-text-secondary);
}
/* 처리 완료 안내 — 탈회 계정 복구·삭제처럼 "됐고, 다음은 이것" 을 말하는 자리.
   에러(.error-message)와 색을 갈라야 한다. 붉은 자리에 쓰면 성공을 실패로 읽는다. */
.notice-message {
    background-color: #e8f5e9;
    border: 1px solid #a5d6a7;
    color: #2e7d32;
    padding: 12px 16px;
    border-radius: 6px;
    font-size: 14px;
    margin-bottom: 20px;
    animation: notice-in 160ms ease-out;
}

@keyframes notice-in { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: translateY(0); } }
@media (prefers-reduced-motion: reduce) { .notice-message { animation: none; } }

[data-theme="dark"] .notice-message {
    background-color: rgba(129, 199, 132, 0.12);
    border-color: rgba(129, 199, 132, 0.35);
    color: #81c784;
}


/* ── 소셜 로그인 — 기본 수단이라 제일 위, 제일 크게 (사용자 결정 2026-09-11) ──────────── */

.social-login { display: flex; flex-direction: column; gap: 8px; }

.social-btn {
  display: flex; align-items: center; justify-content: center; gap: 10px;
  width: 100%; height: 42px; padding: 0 14px;
  font-size: 14px; font-weight: 500; cursor: pointer;
  border-radius: 6px; border: 1px solid transparent;
  transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
}
.social-btn:disabled { opacity: 0.55; cursor: default; }

/* 구글 버튼은 **구글이 정한 모양**을 따른다 — 흰 바탕에 회색 테두리 */
.social-google { background: #fff; border-color: #747775; color: #1f1f1f; }
.social-google:hover:not(:disabled) { background: #f5f5f5; }
/* 네이버는 브랜드 초록 */
.social-naver { background: #03c75a; color: #fff; }
.social-naver:hover:not(:disabled) { background: #02b350; }

.social-spin { animation: social-spin 900ms linear infinite; }
@keyframes social-spin { to { transform: rotate(360deg); } }

/* 같은 이메일이라도 가입 경로가 다르면 다른 계정이다 — 나중에 "자료가 사라졌다" 로 온다 */
.social-note { margin-top: 2px; font-size: 11px; line-height: 1.6; opacity: 0.62; }
.social-error { margin-top: 4px; font-size: 12px; line-height: 1.6; color: #d14343; }
.social-unconfigured {
  padding: 10px 12px; font-size: 12px; line-height: 1.6; border-radius: 6px;
  border: 1px solid #e0d9b8; background: rgba(226, 196, 90, 0.12);
}

/* 「또는」 — 기본 수단과 보조 수단을 가르는 선 */
.login-or {
  display: flex; align-items: center; gap: 10px;
  margin: 16px 0 12px; font-size: 11px; opacity: 0.5;
}
.login-or::before, .login-or::after {
  content: ''; flex: 1 1; height: 1px; background: currentColor; opacity: 0.3;
}

/* 접혀 있던 아이디/비밀번호가 펼쳐질 때 — 즉시 나타나면 어디가 바뀌었는지 놓친다 */
.login-idForm { animation: login-id-in 160ms ease-out; }
@keyframes login-id-in { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: none; } }

/*
 * 다크 모드. **구글 버튼은 구글이 정한 다크 색을 쓴다** — 이 버튼은 브랜드 자산이라
 * 우리 팔레트로 칠하면 안 된다(흰 바탕 #FFFFFF / 어두운 바탕 #131314, 테두리 #8E918F).
 * 다크 화면에 흰 버튼만 덩그러니 남아 있던 것을 고친다.
 *
 * 네이버는 **밝기와 무관하게 같은 초록**(#03C75A)이다 — 네이버 가이드가 그렇게 정해 뒀고,
 * 어두운 배경에서도 대비가 충분하다. 굳이 다크 변형을 만들면 브랜드에서 멀어진다.
 */
[data-theme="dark"] .social-google {
  background: #131314; border-color: #8e918f; color: #e3e3e3;
}
[data-theme="dark"] .social-google:hover:not(:disabled) { background: #1f1f20; }

[data-theme="dark"] .social-unconfigured {
  border-color: #55502f; background: rgba(226, 196, 90, 0.08); color: var(--color-text);
}
[data-theme="dark"] .social-error { color: #e88b7d; }

/* ── 가입 마무리 — 소셜로 계정이 방금 만들어졌을 때 한 단계 ─────────────────── */

.signup-oauth { animation: login-id-in 160ms ease-out; }
.signup-oauth-title { font-size: 16px; font-weight: 600; margin-bottom: 4px; }
.signup-oauth-desc { font-size: 12.5px; line-height: 1.6; opacity: 0.7; margin-bottom: 16px; }
.signup-oauth-hint { margin-top: 5px; font-size: 11px; line-height: 1.6; opacity: 0.62; }
/* 제공자가 정한 값이라 **못 바꾼다** — 입력칸처럼 보이면 고쳐 놓고 왜 안 되냐고 묻게 된다 */
.signup-oauth-fixed {
  display: flex; align-items: baseline; gap: 8px; flex-wrap: wrap;
  padding: 8px 10px; font-size: 13px; border-radius: 6px;
  background: rgba(127, 127, 127, 0.1);
}
.signup-oauth-via { font-size: 11px; opacity: 0.6; }

[data-theme="dark"] .signup-oauth-fixed { background: rgba(255, 255, 255, 0.06); }

@media (prefers-reduced-motion: reduce) {
  .signup-oauth { animation: none; }
  .social-btn { transition: none; }
  .social-spin { animation: none; }
  .login-idForm { animation: none; }
}

/* 체험 계정 — 비밀번호 없이 바로 들어가는 계정 단추(2026-10-14) */
.login-trial { margin-top: 14px; padding: 10px 12px; border: 1px dashed #86efac; border-radius: 8px; background: #f0fdf4; animation: login-trial-in 160ms ease-out; }
.login-trial-title { font-size: 12px; font-weight: 600; color: #166534; margin-bottom: 6px; }
.login-trial-list { display: flex; flex-wrap: wrap; gap: 6px; }
.login-trial-btn { padding: 4px 12px; font-size: 12px; border-radius: 999px; border: 1px solid #86efac; background: #fff; color: #15803d; cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease; }
.login-trial-btn:hover:not(:disabled) { background: #dcfce7; border-color: #4ade80; }
.login-trial-btn:focus-visible { outline: 2px solid #22c55e; outline-offset: 1px; }
.login-trial-btn:disabled { opacity: .55; cursor: default; }
.login-trial-hint { margin-top: 6px; font-size: 11px; line-height: 1.5; color: #4b5563; }
@keyframes login-trial-in { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: none; } }
[data-theme="dark"] .login-trial { background: rgba(34, 197, 94, 0.08); border-color: #166534; }
[data-theme="dark"] .login-trial-title { color: #86efac; }
[data-theme="dark"] .login-trial-btn { background: transparent; color: #86efac; border-color: #166534; }
[data-theme="dark"] .login-trial-btn:hover:not(:disabled) { background: rgba(34, 197, 94, 0.15); }
[data-theme="dark"] .login-trial-hint { color: var(--color-text-secondary, #9ca3af); }
@media (prefers-reduced-motion: reduce) { .login-trial { animation: none; } .login-trial-btn { transition: none; } }
`, "",{"version":3,"sources":["webpack://./src/components/LoginPage.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,4CAA4C;IAC5C,wCAAwC;IACxC,oCAAoC;IACpC,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI;6CACyC;IACzC,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;AAChB;;AAEA;IACI,6DAA6D;IAC7D,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,2CAA2C;AAC3C;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,QAAQ;IACR,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,oCAAoC;IACpC,yCAAyC;IACzC,0DAA0D;AAC9D;AACA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,oCAAoC;IACpC,0CAA0C;IAC1C,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,qCAAqC;IACrC,uCAAuC;AAC3C;AACA;IACI,eAAe;IACf,cAAc;IACd,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,6DAA6D;IAC7D,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,gCAAgC;AACpC;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,UAAU;IACd;AACJ;;AAEA,gBAAgB;AAChB;IACI,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,YAAY;AACZ;IACI;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,mBAAmB;AACnB;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,0BAA0B;IAC1B,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA,6BAA6B;AAC7B;;IAEI,cAAc;IACd,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;;;iEAGiE;AACjE;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;IACnC,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;AAC5B;AACA;+BAC+B;AAC/B;IACI,wBAAwB;AAC5B;AACA;IACI,kCAAkC;AACtC;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,gDAAgD;IAChD,6CAA6C;IAC7C,wBAAwB;IACxB,0DAA0D;IAC1D,kBAAkB;AACtB;AACA;IACI,oCAAoC;IACpC,+CAA+C;AACnD;AACA;IACI,uCAAuC;IACvC,8BAA8B;AAClC;AACA;IACI,oCAAoC;AACxC;AACA;iEACiE;AACjE;;;;IAII,gFAAgF;IAChF,8DAA8D;IAC9D,uCAAuC;IACvC,yDAAiD;IAAjD,iDAAiD,MAAM,oCAAoC;IAC3F,wDAAwD;AAC5D;AACA,4DAA4D;AAC5D;;;;IAII,8CAA8C;IAC9C,6BAA6B;IAC7B,yDAAiD;IAAjD,iDAAiD;AACrD;;AAEA;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,cAAc;AAClB;AACA;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,cAAc;AAClB;AACA;IACI,yCAAyC;IACzC,oCAAoC;IACpC,cAAc;AAClB;AACA;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,WAAW;AACf;AACA;IACI,6DAA6D;IAC7D,+CAA+C;AACnD;AACA;IACI,6DAA6D;IAC7D,aAAa;AACjB;AACA;IACI,8CAA8C;IAC9C,wBAAwB;IACxB,2CAA2C;AAC/C;AACA;IACI,6CAA6C;IAC7C,gDAAgD;AACpD;;AAEA;;IAEI,8CAA8C;AAClD;AACA;IACI,kCAAkC;AACtC;AACA;IACI,2CAA2C;IAC3C,0CAA0C;AAC9C;AACA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;AACA;IACI,wBAAwB,EAAE,8BAA8B,CAAC;;AAE7D;IACI,cAAc;AAClB;AACA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;AACA;IACI,0CAA0C;IAC1C,kBAAkB,SAAS,wDAAwD;AACvF;AACA;IACI,wBAAwB;AAC5B;;AAEA,oBAAoB;AACpB;IACI,qCAAqC;IACrC,0CAA0C;AAC9C;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,8BAA8B;AAClC;AACA;IACI,cAAc;IACd,qCAAqC;IACrC,sCAAsC;AAC1C;AACA;IACI,8BAA8B;IAC9B,gDAAgD;AACpD;AACA;IACI,8BAA8B;AAClC;AACA;IACI,kCAAkC;AACtC;AACA;0DAC0D;AAC1D;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA,uBAAuB,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;AACtH,0CAA0C,kBAAkB,eAAe,EAAE,EAAE;;AAE/E;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,cAAc;AAClB;;;AAGA,qEAAqE;;AAErE,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAEjE;EACE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,SAAS;EACtE,WAAW,EAAE,YAAY,EAAE,eAAe;EAC1C,eAAe,EAAE,gBAAgB,EAAE,eAAe;EAClD,kBAAkB,EAAE,6BAA6B;EACjD,uFAAuF;AACzF;AACA,uBAAuB,aAAa,EAAE,eAAe,EAAE;;AAEvD,6CAA6C;AAC7C,iBAAiB,gBAAgB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC1E,sCAAsC,mBAAmB,EAAE;AAC3D,gBAAgB;AAChB,gBAAgB,mBAAmB,EAAE,WAAW,EAAE;AAClD,qCAAqC,mBAAmB,EAAE;;AAE1D,eAAe,4CAA4C,EAAE;AAC7D,yBAAyB,KAAK,yBAAyB,EAAE,EAAE;;AAE3D,uDAAuD;AACvD,eAAe,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,aAAa,EAAE;AAClF,gBAAgB,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACpF;EACE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB;EACzE,yBAAyB,EAAE,oCAAoC;AACjE;;AAEA,+BAA+B;AAC/B;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,mBAAmB,EAAE,eAAe,EAAE,YAAY;AACpD;AACA;EACE,WAAW,EAAE,SAAO,EAAE,WAAW,EAAE,wBAAwB,EAAE,YAAY;AAC3E;;AAEA,kDAAkD;AAClD,gBAAgB,qCAAqC,EAAE;AACvD,yBAAyB,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,eAAe,EAAE,EAAE;;AAE/G;;;;;;;EAOE;AACF;EACE,mBAAmB,EAAE,qBAAqB,EAAE,cAAc;AAC5D;AACA,0DAA0D,mBAAmB,EAAE;;AAE/E;EACE,qBAAqB,EAAE,oCAAoC,EAAE,wBAAwB;AACvF;AACA,oCAAoC,cAAc,EAAE;;AAEpD,4DAA4D;;AAE5D,gBAAgB,qCAAqC,EAAE;AACvD,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC7E,qBAAqB,iBAAiB,EAAE,gBAAgB,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAC7F,qBAAqB,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,aAAa,EAAE;AACxF,0DAA0D;AAC1D;EACE,aAAa,EAAE,qBAAqB,EAAE,QAAQ,EAAE,eAAe;EAC/D,iBAAiB,EAAE,eAAe,EAAE,kBAAkB;EACtD,oCAAoC;AACtC;AACA,oBAAoB,eAAe,EAAE,YAAY,EAAE;;AAEnD,0CAA0C,qCAAqC,EAAE;;AAEjF;EACE,gBAAgB,eAAe,EAAE;EACjC,cAAc,gBAAgB,EAAE;EAChC,eAAe,eAAe,EAAE;EAChC,gBAAgB,eAAe,EAAE;AACnC;;AAEA,8CAA8C;AAC9C,eAAe,gBAAgB,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,wCAAwC,EAAE;AACpK,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAC5F,oBAAoB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AAC9D,mBAAmB,iBAAiB,EAAE,eAAe,EAAE,oBAAoB,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe;EACvJ,gEAAgE,EAAE;AACpE,wCAAwC,mBAAmB,EAAE,qBAAqB,EAAE;AACpF,iCAAiC,0BAA0B,EAAE,mBAAmB,EAAE;AAClF,4BAA4B,YAAY,EAAE,eAAe,EAAE;AAC3D,oBAAoB,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACxF,4BAA4B,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,eAAe,EAAE,EAAE;AAClH,mCAAmC,mCAAmC,EAAE,qBAAqB,EAAE;AAC/F,yCAAyC,cAAc,EAAE;AACzD,uCAAuC,uBAAuB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACvG,4DAA4D,mCAAmC,EAAE;AACjG,wCAAwC,2CAA2C,EAAE;AACrF,0CAA0C,eAAe,eAAe,EAAE,EAAE,mBAAmB,gBAAgB,EAAE,EAAE","sourcesContent":["/* LoginPage.css - 현재 앱 스타일과 유사한 로그인 페이지 */\n\n.login-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: calc(100vh / var(--app-zoom, 1));\n    /* 단색 페이지 배경 — 카드 형태가 아닌 페이지 한가운데 폼 배치 */\n    background: var(--color-bg, #ffffff);\n    padding: 20px;\n    box-sizing: border-box;\n}\n\n.login-card {\n    /* 카드 그림자/배경/border-radius 제거 — 페이지 콘텐츠로 녹아들게.\n       max-width 만 유지해 가독성 보장. 가운데 폼 묶음 형태. */\n    background: transparent;\n    box-shadow: none;\n    border: none;\n    border-radius: 0;\n    padding: 32px 24px;\n    width: 100%;\n    max-width: 400px;\n    position: relative;\n}\n\n.login-header {\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.login-logo {\n    width: 100%;\n    max-width: 200px;\n    height: auto;\n    margin: 0 auto 30px;\n    display: block;\n    object-fit: contain;\n}\n\n.login-title {\n    font-size: 28px;\n    font-weight: 700;\n    color: #333;\n    margin: 0 0 8px 0;\n    letter-spacing: -0.5px;\n}\n\n.login-subtitle {\n    color: #666;\n    margin: 0;\n    font-size: 14px;\n    font-weight: 400;\n}\n\n.login-form {\n    width: 100%;\n}\n\n.form-group {\n    margin-bottom: 24px;\n}\n\n.form-label {\n    display: block;\n    font-size: 14px;\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 8px;\n}\n\n.form-input {\n    width: 100%;\n    padding: 12px 16px;\n    border: 2px solid #e1e5e9;\n    border-radius: 8px;\n    font-size: 14px;\n    background-color: #fff;\n    transition: all 0.2s ease;\n    box-sizing: border-box;\n}\n\n.form-input:focus {\n    outline: none;\n    border-color: #6c757d;\n    box-shadow: 0 0 0 3px rgba(108, 117, 125, 0.1);\n}\n\n.form-input:disabled {\n    background-color: #f8f9fa;\n    cursor: not-allowed;\n}\n\n.form-input::placeholder {\n    color: #adb5bd;\n}\n\n.error-message {\n    background-color: #ffeaa7;\n    border: 1px solid #fdcb6e;\n    color: #e17055;\n    padding: 12px 16px;\n    border-radius: 6px;\n    font-size: 14px;\n    margin-bottom: 20px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.error-icon {\n    font-size: 16px;\n    flex-shrink: 0;\n}\n\n.error-text {\n    flex: 1;\n    text-align: left;\n}\n\n.button-group {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-bottom: 24px;\n}\n\n.login-button {\n    width: 100%;\n    padding: 14px 20px;\n    border: none;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    text-align: center;\n    position: relative;\n    overflow: hidden;\n}\n\n.login-button.primary {\n    background: linear-gradient(135deg, #6c757d 0%, #495057 100%);\n    color: white;\n}\n\n.login-button.primary:hover:not(:disabled) {\n    background: linear-gradient(135deg, #5a6268 0%, #3d4142 100%);\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);\n}\n\n.login-button.secondary {\n    background-color: #f8f9fa;\n    color: #495057;\n    border: 2px solid #e9ecef;\n}\n\n.login-button.secondary:hover:not(:disabled) {\n    background-color: #e9ecef;\n    border-color: #dee2e6;\n    transform: translateY(-1px);\n}\n\n.login-button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none !important;\n    box-shadow: none !important;\n}\n\n/* 데스크톱 설치 버전 다운로드 섹션 — manifest 있을 때만 표시 */\n.login-downloads {\n    margin-top: 16px;\n    padding: 12px 14px;\n    border: 1px solid #e1e5e9;\n    border-radius: 8px;\n    background: #fafbfc;\n}\n.login-downloads-title {\n    font-size: 13px;\n    font-weight: 600;\n    color: #374151;\n    margin-bottom: 8px;\n}\n.login-downloads-version {\n    font-size: 11px;\n    color: #6b7280;\n    font-weight: 400;\n    margin-left: 4px;\n}\n.login-downloads-list {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n.login-download-link {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: baseline;\n    gap: 6px;\n    text-decoration: none;\n    padding: 6px 10px;\n    border-radius: 6px;\n    font-size: 12px;\n    color: #1e40af;\n    background: rgba(59, 130, 246, 0.06);\n    border: 1px solid rgba(59, 130, 246, 0.2);\n    transition: background 150ms ease, border-color 150ms ease;\n}\n.login-download-link:hover {\n    background: rgba(59, 130, 246, 0.14);\n    border-color: rgba(59, 130, 246, 0.45);\n}\n.login-download-label {\n    font-weight: 600;\n}\n.login-download-size {\n    font-size: 11px;\n    color: #6b7280;\n    font-weight: 400;\n}\n.login-download-count {\n    font-size: 11px;\n    color: #4b5563;\n    font-weight: 500;\n    background: rgba(59, 130, 246, 0.10);\n    border: 1px solid rgba(59, 130, 246, 0.25);\n    border-radius: 10px;\n    padding: 1px 7px;\n    line-height: 1.3;\n}\n[data-theme=\"dark\"] .login-download-count {\n    color: #cbd5e1;\n    background: rgba(108, 182, 255, 0.14);\n    border-color: rgba(108, 182, 255, 0.32);\n}\n.login-download-desc {\n    font-size: 11px;\n    color: #4b5563;\n    flex: 1 1 100%;\n    line-height: 1.35;\n}\n\n.login-footer {\n    text-align: center;\n    border-top: 1px solid #e9ecef;\n    padding-top: 24px;\n    margin-top: 24px;\n}\n\n.footer-text {\n    color: #6c757d;\n    font-size: 13px;\n    line-height: 1.5;\n    margin: 0 0 16px 0;\n}\n\n.demo-info {\n    background-color: #f8f9fa;\n    padding: 12px;\n    border-radius: 6px;\n    border: 1px solid #e9ecef;\n}\n\n.demo-info small {\n    color: #495057;\n    font-size: 12px;\n}\n\n/* 로딩 상태 애니메이션 */\n.login-button.primary:disabled {\n    background: linear-gradient(135deg, #6c757d 0%, #495057 100%);\n    position: relative;\n}\n\n.login-button.primary:disabled::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n    animation: loading 1.5s infinite;\n}\n\n@keyframes loading {\n    0% {\n        left: -100%;\n    }\n    100% {\n        left: 100%;\n    }\n}\n\n/* 회원가입 관련 스타일 */\n.signup-form {\n    width: 100%;\n}\n\n/* 목업 모드 관련 스타일 */\n.mock-info {\n    margin-top: 12px;\n}\n\n.mock-message {\n    background-color: #fff3e0;\n    border: 1px solid #ffb74d;\n    color: #e65100;\n    padding: 12px 16px;\n    border-radius: 8px;\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n}\n\n.mock-icon {\n    font-size: 16px;\n    flex-shrink: 0;\n    margin-top: 2px;\n}\n\n.mock-text p {\n    margin: 0 0 8px 0;\n    font-size: 13px;\n    line-height: 1.4;\n}\n\n.mock-text p:last-child {\n    margin-bottom: 0;\n}\n\n.show-mock-code {\n    background: #ff9800;\n    color: white;\n    border: none;\n    padding: 6px 12px;\n    border-radius: 4px;\n    font-size: 12px;\n    cursor: pointer;\n    font-weight: 500;\n    margin-top: 8px;\n}\n\n.show-mock-code:hover {\n    background: #f57c00;\n}\n\n.mock-complete-info {\n    margin: 16px 0;\n}\n\n.mock-credentials {\n    background-color: #e8f5e8;\n    border: 1px solid #81c784;\n    color: #2e7d32;\n    padding: 16px;\n    border-radius: 8px;\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n}\n\n.mock-credentials .mock-text p {\n    margin: 0 0 4px 0;\n    font-size: 13px;\n    line-height: 1.4;\n}\n\n.mock-credentials .mock-note {\n    font-size: 11px;\n    color: #4caf50;\n    font-style: italic;\n    margin-top: 8px;\n}\n\n.verification-info {\n    margin-bottom: 20px;\n}\n\n.info-message {\n    background-color: #e3f2fd;\n    border: 1px solid #90caf9;\n    color: #1565c0;\n    padding: 16px;\n    border-radius: 8px;\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n}\n\n.info-icon {\n    font-size: 20px;\n    flex-shrink: 0;\n    margin-top: 2px;\n}\n\n.info-text p {\n    margin: 0 0 8px 0;\n    font-size: 14px;\n    line-height: 1.5;\n}\n\n.info-text p:last-child {\n    margin-bottom: 0;\n}\n\n.complete-message {\n    text-align: center;\n    padding: 20px 0;\n}\n\n.success-icon {\n    font-size: 48px;\n    margin-bottom: 16px;\n}\n\n.complete-message h3 {\n    color: #2e7d32;\n    margin: 0 0 16px 0;\n    font-size: 20px;\n    font-weight: 600;\n}\n\n.complete-message p {\n    color: #4a5568;\n    margin: 0 0 12px 0;\n    font-size: 14px;\n    line-height: 1.5;\n}\n\n.auth-toggle {\n    text-align: center;\n    margin-top: 20px;\n    padding-top: 20px;\n    border-top: 1px solid #e9ecef;\n}\n\n.toggle-link {\n    background: none;\n    border: none;\n    color: #6c757d;\n    font-size: 14px;\n    cursor: pointer;\n    text-decoration: none;\n    padding: 8px 0;\n    transition: color 0.2s ease;\n}\n\n.toggle-link:hover {\n    color: #495057;\n}\n\n.toggle-link strong {\n    color: #007bff;\n    font-weight: 600;\n}\n\n.toggle-link strong:hover {\n    text-decoration: underline;\n}\n\n/* 반응형 디자인 */\n@media (max-width: 480px) {\n    .login-container {\n        padding: 10px;\n    }\n    \n    .login-card {\n        padding: 30px 20px;\n    }\n    \n    .login-title {\n        font-size: 24px;\n    }\n    \n    .info-message {\n        padding: 12px;\n        gap: 8px;\n    }\n    \n    .info-text p {\n        font-size: 13px;\n    }\n}\n\n/* 패스워드 찾기 관련 스타일 */\n.forgot-password-form {\n    /* 기본 signup-form 스타일과 동일하게 유지 */\n}\n\n.forgot-password-link {\n    text-align: center;\n    margin-top: 15px;\n}\n\n.link-button {\n    background: none;\n    border: none;\n    color: #007bff;\n    font-size: 13px;\n    cursor: pointer;\n    text-decoration: underline;\n    padding: 5px 0;\n    transition: color 0.2s ease;\n}\n\n.link-button:hover {\n    color: #0056b3;\n    text-decoration: none;\n}\n\n/* 성공/에러 메시지에 작은 텍스트 스타일 추가 */\n.success-text small,\n.error-text small {\n    display: block;\n    margin-top: 8px;\n    opacity: 0.8;\n    font-style: italic;\n}\n\n/* 패스워드 저장 체크박스 스타일 */\n.checkbox-label {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    user-select: none;\n    font-size: 14px;\n    color: #495057;\n    margin-bottom: 0;\n}\n\n.checkbox-input {\n    margin-right: 8px;\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n    accent-color: #6c757d;\n}\n\n.checkbox-text {\n    flex: 1;\n    font-weight: 500;\n}\n\n.checkbox-label:hover .checkbox-text {\n    color: #333;\n}\n\n/* ============================================================\n * 다크 모드 — [data-theme=\"dark\"] 활성 시 적용\n * 시스템 토글로 라이트/다크 자동 전환. 모든 색은 변수 또는 다크 톤 hardcode.\n * ============================================================ */\n[data-theme=\"dark\"] .login-container {\n    background: var(--color-bg, #1e1e1e);\n}\n[data-theme=\"dark\"] .login-card {\n    /* 카드 시각 효과 제거 — 다크 페이지에 자연스럽게 녹게 */\n    background: transparent;\n    box-shadow: none;\n    border: none;\n    color: var(--color-text);\n}\n/* 로고는 라이트(logo1.png) / 다크(logo1_dark.png) 별도 PNG 로 분기 (LoginPage.js).\n   CSS filter 는 더 이상 사용하지 않음. */\n[data-theme=\"dark\"] .login-title {\n    color: var(--color-text);\n}\n[data-theme=\"dark\"] .login-subtitle {\n    color: var(--color-text-secondary);\n}\n[data-theme=\"dark\"] .form-label {\n    color: var(--color-text);\n}\n[data-theme=\"dark\"] .form-input {\n    background-color: var(--color-input-bg, #3c3c3c);\n    border-color: var(--color-input-border, #555);\n    color: var(--color-text);\n    /* native 자동완성 드롭다운, spinner, 비밀번호 토글 아이콘 등이 다크 톤으로 렌더되게 */\n    color-scheme: dark;\n}\n[data-theme=\"dark\"] .form-input:focus {\n    border-color: var(--color-accent-fg);\n    box-shadow: 0 0 0 3px rgba(108, 182, 255, 0.18);\n}\n[data-theme=\"dark\"] .form-input:disabled {\n    background-color: rgba(60, 60, 60, 0.5);\n    color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .form-input::placeholder {\n    color: var(--color-text-muted, #777);\n}\n/* 브라우저 자동완성 (autofill) 시 강제 노란/흰 배경 덮기 — Chrome/Safari 의 -webkit-autofill 트릭.\n   inset box-shadow 로 배경을 채우고 -webkit-text-fill-color 로 글자색 지정. */\n[data-theme=\"dark\"] .form-input:-webkit-autofill,\n[data-theme=\"dark\"] .form-input:-webkit-autofill:hover,\n[data-theme=\"dark\"] .form-input:-webkit-autofill:focus,\n[data-theme=\"dark\"] .form-input:-webkit-autofill:active {\n    -webkit-box-shadow: 0 0 0 1000px var(--color-input-bg, #3c3c3c) inset !important;\n    -webkit-text-fill-color: var(--color-text, #d4d4d4) !important;\n    caret-color: var(--color-text, #d4d4d4);\n    transition: background-color 5000s ease-in-out 0s;     /* autofill 색 전환 지연 — 렌더 직후 깜박임 회피 */\n    border-color: var(--color-input-border, #555) !important;\n}\n/* 라이트 모드 autofill 도 색상계 일관성을 위해 명시 (브라우저 기본 노란 배경 → 흰 배경) */\n.form-input:-webkit-autofill,\n.form-input:-webkit-autofill:hover,\n.form-input:-webkit-autofill:focus,\n.form-input:-webkit-autofill:active {\n    -webkit-box-shadow: 0 0 0 1000px #ffffff inset;\n    -webkit-text-fill-color: #333;\n    transition: background-color 5000s ease-in-out 0s;\n}\n\n[data-theme=\"dark\"] .error-message {\n    background-color: rgba(229, 115, 115, 0.12);\n    border-color: rgba(229, 115, 115, 0.4);\n    color: #ff8a80;\n}\n[data-theme=\"dark\"] .info-message {\n    background-color: rgba(108, 182, 255, 0.12);\n    border-color: rgba(108, 182, 255, 0.4);\n    color: #93c5fd;\n}\n[data-theme=\"dark\"] .mock-message {\n    background-color: rgba(255, 152, 0, 0.12);\n    border-color: rgba(255, 152, 0, 0.4);\n    color: #ffb74d;\n}\n[data-theme=\"dark\"] .mock-credentials {\n    background-color: rgba(129, 199, 132, 0.12);\n    border-color: rgba(129, 199, 132, 0.4);\n    color: #a5d6a7;\n}\n[data-theme=\"dark\"] .mock-credentials .mock-note {\n    color: #81c784;\n}\n\n[data-theme=\"dark\"] .login-button.primary {\n    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n    color: #fff;\n}\n[data-theme=\"dark\"] .login-button.primary:hover:not(:disabled) {\n    background: linear-gradient(135deg, #6cb6ff 0%, #3b82f6 100%);\n    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.45);\n}\n[data-theme=\"dark\"] .login-button.primary:disabled {\n    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n    opacity: 0.55;\n}\n[data-theme=\"dark\"] .login-button.secondary {\n    background-color: var(--color-btn-bg, #3c3c3c);\n    color: var(--color-text);\n    border-color: var(--color-btn-border, #555);\n}\n[data-theme=\"dark\"] .login-button.secondary:hover:not(:disabled) {\n    background-color: var(--color-hover, #37373d);\n    border-color: var(--color-hover-border, #5a5a5a);\n}\n\n[data-theme=\"dark\"] .login-footer,\n[data-theme=\"dark\"] .auth-toggle {\n    border-top-color: var(--color-border, #404040);\n}\n[data-theme=\"dark\"] .footer-text {\n    color: var(--color-text-secondary);\n}\n[data-theme=\"dark\"] .demo-info {\n    background-color: rgba(255, 255, 255, 0.04);\n    border-color: var(--color-border, #404040);\n}\n[data-theme=\"dark\"] .demo-info small {\n    color: var(--color-text-secondary);\n}\n\n[data-theme=\"dark\"] .toggle-link {\n    color: var(--color-text-secondary);\n}\n[data-theme=\"dark\"] .toggle-link:hover {\n    color: var(--color-text);\n}\n[data-theme=\"dark\"] .toggle-link strong {\n    color: var(--color-accent-fg);\n}\n\n[data-theme=\"dark\"] .link-button {\n    color: var(--color-accent-fg);\n}\n[data-theme=\"dark\"] .link-button:hover {\n    color: var(--color-text); background: var(--color-hover);}\n\n[data-theme=\"dark\"] .complete-message h3 {\n    color: #81c784;\n}\n[data-theme=\"dark\"] .complete-message p {\n    color: var(--color-text-secondary);\n}\n\n[data-theme=\"dark\"] .checkbox-label {\n    color: var(--color-text-secondary);\n}\n[data-theme=\"dark\"] .checkbox-input {\n    accent-color: var(--color-accent, #6cb6ff);\n    color-scheme: dark;        /* checkbox native 위젯 다크 톤 (체크 안 된 상태의 흰색 박스 → 어두운 박스) */\n}\n[data-theme=\"dark\"] .checkbox-label:hover .checkbox-text {\n    color: var(--color-text);\n}\n\n/* 다크 모드 — 다운로드 섹션 */\n[data-theme=\"dark\"] .login-downloads {\n    background: rgba(255, 255, 255, 0.03);\n    border-color: var(--color-border, #404040);\n}\n[data-theme=\"dark\"] .login-downloads-title {\n    color: var(--color-text);\n}\n[data-theme=\"dark\"] .login-downloads-version {\n    color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .login-download-link {\n    color: #93c5fd;\n    background: rgba(108, 182, 255, 0.08);\n    border-color: rgba(108, 182, 255, 0.3);\n}\n[data-theme=\"dark\"] .login-download-link:hover {\n    background: var(--color-hover);\n    border-color: var(--color-hover-border, #5a5a5a);\n}\n[data-theme=\"dark\"] .login-download-size {\n    color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .login-download-desc {\n    color: var(--color-text-secondary);\n}\n/* 처리 완료 안내 — 탈회 계정 복구·삭제처럼 \"됐고, 다음은 이것\" 을 말하는 자리.\n   에러(.error-message)와 색을 갈라야 한다. 붉은 자리에 쓰면 성공을 실패로 읽는다. */\n.notice-message {\n    background-color: #e8f5e9;\n    border: 1px solid #a5d6a7;\n    color: #2e7d32;\n    padding: 12px 16px;\n    border-radius: 6px;\n    font-size: 14px;\n    margin-bottom: 20px;\n    animation: notice-in 160ms ease-out;\n}\n\n@keyframes notice-in { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: translateY(0); } }\n@media (prefers-reduced-motion: reduce) { .notice-message { animation: none; } }\n\n[data-theme=\"dark\"] .notice-message {\n    background-color: rgba(129, 199, 132, 0.12);\n    border-color: rgba(129, 199, 132, 0.35);\n    color: #81c784;\n}\n\n\n/* ── 소셜 로그인 — 기본 수단이라 제일 위, 제일 크게 (사용자 결정 2026-09-11) ──────────── */\n\n.social-login { display: flex; flex-direction: column; gap: 8px; }\n\n.social-btn {\n  display: flex; align-items: center; justify-content: center; gap: 10px;\n  width: 100%; height: 42px; padding: 0 14px;\n  font-size: 14px; font-weight: 500; cursor: pointer;\n  border-radius: 6px; border: 1px solid transparent;\n  transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease;\n}\n.social-btn:disabled { opacity: 0.55; cursor: default; }\n\n/* 구글 버튼은 **구글이 정한 모양**을 따른다 — 흰 바탕에 회색 테두리 */\n.social-google { background: #fff; border-color: #747775; color: #1f1f1f; }\n.social-google:hover:not(:disabled) { background: #f5f5f5; }\n/* 네이버는 브랜드 초록 */\n.social-naver { background: #03c75a; color: #fff; }\n.social-naver:hover:not(:disabled) { background: #02b350; }\n\n.social-spin { animation: social-spin 900ms linear infinite; }\n@keyframes social-spin { to { transform: rotate(360deg); } }\n\n/* 같은 이메일이라도 가입 경로가 다르면 다른 계정이다 — 나중에 \"자료가 사라졌다\" 로 온다 */\n.social-note { margin-top: 2px; font-size: 11px; line-height: 1.6; opacity: 0.62; }\n.social-error { margin-top: 4px; font-size: 12px; line-height: 1.6; color: #d14343; }\n.social-unconfigured {\n  padding: 10px 12px; font-size: 12px; line-height: 1.6; border-radius: 6px;\n  border: 1px solid #e0d9b8; background: rgba(226, 196, 90, 0.12);\n}\n\n/* 「또는」 — 기본 수단과 보조 수단을 가르는 선 */\n.login-or {\n  display: flex; align-items: center; gap: 10px;\n  margin: 16px 0 12px; font-size: 11px; opacity: 0.5;\n}\n.login-or::before, .login-or::after {\n  content: ''; flex: 1; height: 1px; background: currentColor; opacity: 0.3;\n}\n\n/* 접혀 있던 아이디/비밀번호가 펼쳐질 때 — 즉시 나타나면 어디가 바뀌었는지 놓친다 */\n.login-idForm { animation: login-id-in 160ms ease-out; }\n@keyframes login-id-in { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: none; } }\n\n/*\n * 다크 모드. **구글 버튼은 구글이 정한 다크 색을 쓴다** — 이 버튼은 브랜드 자산이라\n * 우리 팔레트로 칠하면 안 된다(흰 바탕 #FFFFFF / 어두운 바탕 #131314, 테두리 #8E918F).\n * 다크 화면에 흰 버튼만 덩그러니 남아 있던 것을 고친다.\n *\n * 네이버는 **밝기와 무관하게 같은 초록**(#03C75A)이다 — 네이버 가이드가 그렇게 정해 뒀고,\n * 어두운 배경에서도 대비가 충분하다. 굳이 다크 변형을 만들면 브랜드에서 멀어진다.\n */\n[data-theme=\"dark\"] .social-google {\n  background: #131314; border-color: #8e918f; color: #e3e3e3;\n}\n[data-theme=\"dark\"] .social-google:hover:not(:disabled) { background: #1f1f20; }\n\n[data-theme=\"dark\"] .social-unconfigured {\n  border-color: #55502f; background: rgba(226, 196, 90, 0.08); color: var(--color-text);\n}\n[data-theme=\"dark\"] .social-error { color: #e88b7d; }\n\n/* ── 가입 마무리 — 소셜로 계정이 방금 만들어졌을 때 한 단계 ─────────────────── */\n\n.signup-oauth { animation: login-id-in 160ms ease-out; }\n.signup-oauth-title { font-size: 16px; font-weight: 600; margin-bottom: 4px; }\n.signup-oauth-desc { font-size: 12.5px; line-height: 1.6; opacity: 0.7; margin-bottom: 16px; }\n.signup-oauth-hint { margin-top: 5px; font-size: 11px; line-height: 1.6; opacity: 0.62; }\n/* 제공자가 정한 값이라 **못 바꾼다** — 입력칸처럼 보이면 고쳐 놓고 왜 안 되냐고 묻게 된다 */\n.signup-oauth-fixed {\n  display: flex; align-items: baseline; gap: 8px; flex-wrap: wrap;\n  padding: 8px 10px; font-size: 13px; border-radius: 6px;\n  background: rgba(127, 127, 127, 0.1);\n}\n.signup-oauth-via { font-size: 11px; opacity: 0.6; }\n\n[data-theme=\"dark\"] .signup-oauth-fixed { background: rgba(255, 255, 255, 0.06); }\n\n@media (prefers-reduced-motion: reduce) {\n  .signup-oauth { animation: none; }\n  .social-btn { transition: none; }\n  .social-spin { animation: none; }\n  .login-idForm { animation: none; }\n}\n\n/* 체험 계정 — 비밀번호 없이 바로 들어가는 계정 단추(2026-10-14) */\n.login-trial { margin-top: 14px; padding: 10px 12px; border: 1px dashed #86efac; border-radius: 8px; background: #f0fdf4; animation: login-trial-in 160ms ease-out; }\n.login-trial-title { font-size: 12px; font-weight: 600; color: #166534; margin-bottom: 6px; }\n.login-trial-list { display: flex; flex-wrap: wrap; gap: 6px; }\n.login-trial-btn { padding: 4px 12px; font-size: 12px; border-radius: 999px; border: 1px solid #86efac; background: #fff; color: #15803d; cursor: pointer;\n  transition: background-color 150ms ease, border-color 150ms ease; }\n.login-trial-btn:hover:not(:disabled) { background: #dcfce7; border-color: #4ade80; }\n.login-trial-btn:focus-visible { outline: 2px solid #22c55e; outline-offset: 1px; }\n.login-trial-btn:disabled { opacity: .55; cursor: default; }\n.login-trial-hint { margin-top: 6px; font-size: 11px; line-height: 1.5; color: #4b5563; }\n@keyframes login-trial-in { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: none; } }\n[data-theme=\"dark\"] .login-trial { background: rgba(34, 197, 94, 0.08); border-color: #166534; }\n[data-theme=\"dark\"] .login-trial-title { color: #86efac; }\n[data-theme=\"dark\"] .login-trial-btn { background: transparent; color: #86efac; border-color: #166534; }\n[data-theme=\"dark\"] .login-trial-btn:hover:not(:disabled) { background: rgba(34, 197, 94, 0.15); }\n[data-theme=\"dark\"] .login-trial-hint { color: var(--color-text-secondary, #9ca3af); }\n@media (prefers-reduced-motion: reduce) { .login-trial { animation: none; } .login-trial-btn { transition: none; } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
